// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
			.bsg-high-contrast-button {
				display: flex;
				align-items: center;
				background: rgba(36, 31, 33, 0.6);
				border: 1px solid #f4ece1;
				border-radius: 24px;
				padding: 8px 14px;
				color: #f4ece1;
				cursor: pointer;
				transition: all 0.2s ease;
				font-family: AppFont, sans-serif;
				font-size: 14px;
			}

			.bsg-high-contrast-button:focus {
				outline: 2px solid #0078d7;
				box-shadow: 0 0 0 4px rgba(0, 120, 215, 0.25);
			}

			.bsg-high-contrast-active {
				background: #f4ece1;
				color: #241f21;
			}

			.bsg-high-contrast-icon {
				display: flex;
				align-items: center;
				margin-right: 8px;
			}

			.bsg-high-contrast-icon ion-icon {
				font-size: 20px;
			}

			/* Adapt for small screens */
			@media (max-width: 480px) {
				.bsg-high-contrast-text {
					display: none;
				}

				.bsg-high-contrast-button {
					padding: 8px;
				}

				.bsg-high-contrast-icon {
					margin-right: 0;
				}
			}
		`, "",{"version":3,"sources":["webpack://./src/app/shared-module/hight.contrast.component.ts"],"names":[],"mappings":";GACG;IACC,aAAa;IACb,mBAAmB;IACnB,iCAAiC;IACjC,yBAAyB;IACzB,mBAAmB;IACnB,iBAAiB;IACjB,cAAc;IACd,eAAe;IACf,yBAAyB;IACzB,gCAAgC;IAChC,eAAe;GAChB;;GAEA;IACC,0BAA0B;IAC1B,6CAA6C;GAC9C;;GAEA;IACC,mBAAmB;IACnB,cAAc;GACf;;GAEA;IACC,aAAa;IACb,mBAAmB;IACnB,iBAAiB;GAClB;;GAEA;IACC,eAAe;GAChB;;GAEA,4BAA4B;GAC5B;IACC;KACC,aAAa;IACd;;IAEA;KACC,YAAY;IACb;;IAEA;KACC,eAAe;IAChB;GACD","sourcesContent":["\n\t\t\t.bsg-high-contrast-button {\n\t\t\t\tdisplay: flex;\n\t\t\t\talign-items: center;\n\t\t\t\tbackground: rgba(36, 31, 33, 0.6);\n\t\t\t\tborder: 1px solid #f4ece1;\n\t\t\t\tborder-radius: 24px;\n\t\t\t\tpadding: 8px 14px;\n\t\t\t\tcolor: #f4ece1;\n\t\t\t\tcursor: pointer;\n\t\t\t\ttransition: all 0.2s ease;\n\t\t\t\tfont-family: AppFont, sans-serif;\n\t\t\t\tfont-size: 14px;\n\t\t\t}\n\n\t\t\t.bsg-high-contrast-button:focus {\n\t\t\t\toutline: 2px solid #0078d7;\n\t\t\t\tbox-shadow: 0 0 0 4px rgba(0, 120, 215, 0.25);\n\t\t\t}\n\n\t\t\t.bsg-high-contrast-active {\n\t\t\t\tbackground: #f4ece1;\n\t\t\t\tcolor: #241f21;\n\t\t\t}\n\n\t\t\t.bsg-high-contrast-icon {\n\t\t\t\tdisplay: flex;\n\t\t\t\talign-items: center;\n\t\t\t\tmargin-right: 8px;\n\t\t\t}\n\n\t\t\t.bsg-high-contrast-icon ion-icon {\n\t\t\t\tfont-size: 20px;\n\t\t\t}\n\n\t\t\t/* Adapt for small screens */\n\t\t\t@media (max-width: 480px) {\n\t\t\t\t.bsg-high-contrast-text {\n\t\t\t\t\tdisplay: none;\n\t\t\t\t}\n\n\t\t\t\t.bsg-high-contrast-button {\n\t\t\t\t\tpadding: 8px;\n\t\t\t\t}\n\n\t\t\t\t.bsg-high-contrast-icon {\n\t\t\t\t\tmargin-right: 0;\n\t\t\t\t}\n\t\t\t}\n\t\t"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
